import { useEffect } from "react";

/**
 * Adds the `in` class to any `.clk-reveal` element when it scrolls into view.
 * Lightweight, dependency-free, and respects reduced-motion via CSS.
 */
export default function useReveal(deps = []) {
    useEffect(() => {
        const nodes = Array.from(document.querySelectorAll(".clk-reveal"));
        if (!nodes.length) return undefined;

        if (typeof IntersectionObserver === "undefined") {
            nodes.forEach((n) => n.classList.add("in"));
            return undefined;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("in");
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.14, rootMargin: "0px 0px -8% 0px" }
        );

        nodes.forEach((n) => observer.observe(n));
        return () => observer.disconnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
